/* src/app/components/case/case-details/case-details.component.scss */
.cell {
  padding: 10px;
  padding-left: 20px;
}
.title {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.54);
  padding-bottom: 5px;
}
.case-index-warning {
  background: #FEC006;
}
:host-context(.dark-theme) .title {
  color: rgba(255, 255, 255, 0.6);
}
:host-context(.dark-theme) .case-index-warning {
  background-color: #f9af1f;
  color: black;
}
/*# sourceMappingURL=case-details.component.css.map */
